export default "__VITE_ASSET__DLIS5_xF__"